"use client";

import { useTradieRole } from "@/lib/_context/tradieRoleContext";

type HeaderProps = {
  title?: string;
  description?: string;
};

export default function Header({
  title = "Find your next job",
  description = "Search for jobs, connect with tradies, and get your projects done",
}: HeaderProps) {
  const { activeTradieRole } = useTradieRole();

  // Set background color based on role: blue for diyer, green for tradie
  const backgroundColor =
    activeTradieRole === "tradie" ? "bg-custom-blue-dark" : "bg-custom-blue";

  return (
    <header className={`${backgroundColor} text-white`}>
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="font-bold text-4xl tracking-tight sm:text-5xl">
          {title || "Find your next job"}
        </h1>
        <p className="mt-4 text-blue-100 text-lg sm:text-xl">
          {description ||
            "Search for jobs, connect with tradies, and get your projects done"}
        </p>
      </div>
    </header>
  );
}
